// Complete list of airport transfers with pricing
// Porto Airport From/To destinations

export const AIRPORT_TRANSFERS = [
  { id: 'amarante', name: 'Amarante', price3pax: 80, price4to7pax: 95, km: 65, country: 'Portugal' },
  { id: 'arcos-valdevez', name: 'Arcos De Valdevez', price3pax: 120, price4to7pax: 145, km: 105, country: 'Portugal' },
  { id: 'aveiro', name: 'Aveiro', price3pax: 110, price4to7pax: 130, km: 90, country: 'Portugal' },
  { id: 'baiona', name: 'Baiona', price3pax: 175, price4to7pax: 215, km: 160, country: 'Spain' },
  { id: 'barcelos', name: 'Barcelos', price3pax: 75, price4to7pax: 90, km: 55, country: 'Portugal' },
  { id: 'braga', name: 'Braga', price3pax: 65, price4to7pax: 80, km: 55, country: 'Portugal' },
  { id: 'braganca', name: 'Bragança', price3pax: 250, price4to7pax: 310, km: 210, country: 'Portugal' },
  { id: 'bucaco', name: 'Buçaco', price3pax: 150, price4to7pax: 185, km: 120, country: 'Portugal' },
  { id: 'chaves', name: 'Chaves', price3pax: 180, price4to7pax: 220, km: 150, country: 'Portugal' },
  { id: 'coimbra', name: 'Coimbra', price3pax: 165, price4to7pax: 200, km: 135, country: 'Portugal' },
  { id: 'la-coruna', name: 'La Coruña', price3pax: 370, price4to7pax: 450, km: 300, country: 'Spain' },
  { id: 'ermesinde', name: 'Ermesinde', price3pax: 30, price4to7pax: 40, km: 20, country: 'Portugal' },
  { id: 'espinho', name: 'Espinho', price3pax: 40, price4to7pax: 50, km: 40, country: 'Portugal' },
  { id: 'esposende', name: 'Esposende', price3pax: 50, price4to7pax: 65, km: 45, country: 'Portugal' },
  { id: 'famalicao', name: 'Famalicão', price3pax: 40, price4to7pax: 50, km: 40, country: 'Portugal' },
  { id: 'fatima', name: 'Fátima', price3pax: 250, price4to7pax: 310, km: 210, country: 'Portugal' },
  { id: 'figueira-foz', name: 'Figueira Da Foz', price3pax: 185, price4to7pax: 230, km: 155, country: 'Portugal' },
  { id: 'gaia', name: 'Vila Nova de Gaia', price3pax: 35, price4to7pax: 45, km: 25, country: 'Portugal' },
  { id: 'guarda', name: 'Guarda', price3pax: 255, price4to7pax: 320, km: 220, country: 'Portugal' },
  { id: 'guimaraes', name: 'Guimarães', price3pax: 65, price4to7pax: 80, km: 55, country: 'Portugal' },
  { id: 'ilhavo', name: 'Ílhavo', price3pax: 115, price4to7pax: 145, km: 95, country: 'Portugal' },
  { id: 'lamego', name: 'Lamego', price3pax: 160, price4to7pax: 200, km: 145, country: 'Portugal' },
  { id: 'leiria', name: 'Leiria', price3pax: 235, price4to7pax: 295, km: 200, country: 'Portugal' },
  { id: 'lugo', name: 'Lugo', price3pax: 360, price4to7pax: 450, km: 310, country: 'Spain' },
  { id: 'miranda-douro', name: 'Miranda do Douro', price3pax: 315, price4to7pax: 400, km: 265, country: 'Portugal' },
  { id: 'mirandela', name: 'Mirandela', price3pax: 185, price4to7pax: 235, km: 160, country: 'Portugal' },
  { id: 'moncao', name: 'Monção', price3pax: 160, price4to7pax: 200, km: 135, country: 'Portugal' },
  { id: 'oliveira-azemeis', name: 'Oliveira De Azeméis', price3pax: 75, price4to7pax: 95, km: 65, country: 'Portugal' },
  { id: 'porto-centre', name: 'Porto Centro', price3pax: 30, price4to7pax: 40, km: 20, country: 'Portugal' },
  { id: 'ourense', name: 'Ourense', price3pax: 250, price4to7pax: 315, km: 215, country: 'Spain' },
  { id: 'ovar', name: 'Ovar', price3pax: 60, price4to7pax: 75, km: 55, country: 'Portugal' },
  { id: 'pacos-ferreira', name: 'Paços De Ferreira', price3pax: 45, price4to7pax: 55, km: 35, country: 'Portugal' },
  { id: 'paredes-coura', name: 'Paredes De Coura', price3pax: 135, price4to7pax: 170, km: 110, country: 'Portugal' },
  { id: 'penafiel', name: 'Penafiel', price3pax: 50, price4to7pax: 65, km: 45, country: 'Portugal' },
  { id: 'peso-regua', name: 'Peso Da Régua', price3pax: 145, price4to7pax: 185, km: 125, country: 'Portugal' },
  { id: 'ponte-barca', name: 'Ponte da Barca', price3pax: 120, price4to7pax: 145, km: 100, country: 'Portugal' },
  { id: 'ponte-lima', name: 'Ponte de Lima', price3pax: 100, price4to7pax: 125, km: 85, country: 'Portugal' },
  { id: 'pontevedra', name: 'Pontevedra', price3pax: 200, price4to7pax: 250, km: 170, country: 'Spain' },
  { id: 'povoa-varzim', name: 'Póvoa De Varzim', price3pax: 35, price4to7pax: 45, km: 30, country: 'Portugal' },
  { id: 'santa-maria-feira', name: 'Santa Maria da Feira', price3pax: 55, price4to7pax: 70, km: 50, country: 'Portugal' },
  { id: 'santiago-compostela', name: 'Santiago de Compostela', price3pax: 275, price4to7pax: 340, km: 230, country: 'Spain' },
  { id: 'santo-tirso', name: 'Santo Tirso', price3pax: 35, price4to7pax: 45, km: 30, country: 'Portugal' },
  { id: 'sao-joao-madeira', name: 'São João Da Madeira', price3pax: 60, price4to7pax: 75, km: 55, country: 'Portugal' },
  { id: 'valenca', name: 'Valença', price3pax: 135, price4to7pax: 170, km: 120, country: 'Portugal' },
  { id: 'valpacos', name: 'Valpaços', price3pax: 200, price4to7pax: 250, km: 160, country: 'Portugal' },
  { id: 'viana-castelo', name: 'Viana do Castelo', price3pax: 80, price4to7pax: 100, km: 70, country: 'Portugal' },
  { id: 'vidago', name: 'Vidago', price3pax: 160, price4to7pax: 200, km: 135, country: 'Portugal' },
  { id: 'vigo', name: 'Vigo', price3pax: 180, price4to7pax: 225, km: 150, country: 'Spain' },
  { id: 'vila-conde', name: 'Vila Do Conde', price3pax: 30, price4to7pax: 40, km: 25, country: 'Portugal' },
  { id: 'vila-real', name: 'Vila Real', price3pax: 125, price4to7pax: 155, km: 100, country: 'Portugal' },
  { id: 'viseu', name: 'Viseu', price3pax: 170, price4to7pax: 210, km: 140, country: 'Portugal' },
];

// Get price for a destination based on passenger count
export const getTransferPrice = (destinationId, passengers) => {
  const transfer = AIRPORT_TRANSFERS.find(t => t.id === destinationId);
  if (!transfer) return null;
  
  const passengerCount = parseInt(passengers);
  if (passengerCount <= 3) {
    return transfer.price3pax;
  } else {
    return transfer.price4to7pax;
  }
};

// Round-trip discount: 10% off the doubled price
export const ROUND_TRIP_DISCOUNT = 0.10;

// Compute final price based on direction (one-way or round-trip)
export const getDirectionalPrice = (destinationId, passengers, direction) => {
  const base = getTransferPrice(destinationId, passengers);
  if (base == null) return null;
  if (direction === 'round_trip') {
    return Math.round(base * 2 * (1 - ROUND_TRIP_DISCOUNT));
  }
  return base;
};

// Calculate savings for round-trip vs two one-way trips
export const getRoundTripSavings = (destinationId, passengers) => {
  const base = getTransferPrice(destinationId, passengers);
  if (base == null) return 0;
  return Math.round(base * 2 * ROUND_TRIP_DISCOUNT);
};

// Get transfer details
export const getTransferDetails = (destinationId) => {
  return AIRPORT_TRANSFERS.find(t => t.id === destinationId);
};

// Search transfers by name
export const searchTransfers = (query) => {
  if (!query || query.length < 2) return [];
  
  const lowerQuery = query.toLowerCase();
  return AIRPORT_TRANSFERS.filter(transfer => 
    transfer.name.toLowerCase().includes(lowerQuery)
  );
};
